import React from 'react'
import { withIcon } from '../../withIcon'

function PlayPlaylistIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <rect x="4" y="9" width="16" height="11" rx="1" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M14 14.5L10 16.5V12.5L14 14.5Z" fill="white"/>
      <path d="M5 7.25C5 6.83579 5.33579 6.5 5.75 6.5H18.25C18.6642 6.5 19 6.83579 19 7.25C19 7.66421 18.6642 8 18.25 8H5.75C5.33579 8 5 7.66421 5 7.25Z" fill={color}/>
      <path d="M6 4.75C6 4.33579 6.33579 4 6.75 4H17.25C17.6642 4 18 4.33579 18 4.75C18 5.16421 17.6642 5.5 17.25 5.5H6.75C6.33579 5.5 6 5.16421 6 4.75Z" fill={color}/>
    </svg>
  )
}

export default withIcon(PlayPlaylistIcon)
